var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoreMenuOption',{attrs:{"label":_vm.$tr('signOut'),"link":_vm.url,"icon":"logout"}})}
var staticRenderFns = []

export { render, staticRenderFns }